import { Bridge } from "./bridge";
import { useMountSignIn } from "./mountApp";
import { store } from "./store";
import { ConfigProvider } from '@portkey/did-ui-react';
export function initBridge(_ref) {
  var baseConfig = _ref.baseConfig,
    wallets = _ref.wallets,
    didConfig = _ref.didConfig;
  var bridgeInstance = new Bridge(wallets, baseConfig);
  ConfigProvider.setGlobalConfig(didConfig);
  return {
    instance: bridgeInstance,
    store: store,
    getSignIn: useMountSignIn.bind(null, bridgeInstance, wallets, baseConfig)
  };
}
import * as _PortkeyDid from '@portkey/did-ui-react';
export { _PortkeyDid as PortkeyDid }; // export { demoFn } from './ui';